import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { trackMixpanelEvent } from 'utils/analytics';

import Banner from '@/shared/components/atoms/Banner';
import { Button } from '@/shared/components/atoms/Button';
import { Typography } from '@/shared/components/atoms/Typography';
import routes from '@/shared/constant/routes';
import { useAuth } from '@/shared/hooks/context/auth';
import { useFreeTrial } from '@/shared/hooks/useFreeTrial';

const SubscribeBanner = () => {
  const { user } = useAuth();
  const { push } = useRouter();
  const { t } = useTranslation('common');

  const { freeTrialDaysLeft, freeTrialOver } = useFreeTrial();

  return freeTrialDaysLeft !== undefined ? (
    <Banner bg={freeTrialDaysLeft > 0 ? 'bg-surface-20' : 'bg-primary-default'}>
      <div className='flex w-full flex-col gap-2 tablet:w-auto tablet:flex-row tablet:items-center tablet:gap-32'>
        <Typography
          variant='subtitle2'
          className={classNames(freeTrialDaysLeft <= 0 ? 'text-white' : '')}
        >
          {freeTrialDaysLeft > 0
            ? t('days-left-in-trial', {
                days: freeTrialDaysLeft,
              })
            : t('subscribe-promo-card', { promo: '$100', code: 'SAVE100' })}
        </Typography>
        <Button
          onClick={() => {
            trackMixpanelEvent('Subscribe Now', user);
            trackMixpanelEvent('Promo code CTR', user);
            push(routes.subscription);
          }}
          size='none'
          color={freeTrialDaysLeft > 0 ? 'primary' : 'secondary'}
          className='flex h-40 items-center px-16 font-medium'
        >
          {freeTrialOver
            ? t('promo-cta', { saving: '$100' })
            : t('subscribe-now')}
        </Button>
      </div>
    </Banner>
  ) : null;
};

export default SubscribeBanner;
